const FILTER_TYPE = require('./advance-filter/filter-type-enum');
const _ = require('lodash');
module.exports = function (FiltersService, settingsService, $state, $rootScope, $timeout, breakpointsService) {
    return {
        restrict: 'E',
        scope: {
            sortSettingGroup: '@',
            pageName: '=?',
            unitName: '@'
        },
        link(scope) {
            scope.sorting = {};
            scope.isLoading = true;
            scope.filtersService = FiltersService;
            scope.sortSettingGroup = scope.sortSettingGroup || 'Browse';
            scope.unitName = scope.unitName || 'product';
            scope.hideUnavailableItems = false;
            scope.isDesktopOrTablet = breakpointsService.isMediumFormat() || breakpointsService.isLargeFormat();
            scope.filterType = {
                price: FILTER_TYPE.PRICE,
                range: FILTER_TYPE.PRICE_RANGE
            };

            scope.model = {};

            settingsService.getSettingValue(scope.sortSettingGroup, 'SortOptions').then((sortOptions) => {
                scope.sorting.sortTypes = sortOptions;
                scope.sorting.sortType = $state.params.sortby ? _.filter(sortOptions, { Value: $state.params.sortby })[0] : null;
            });

            scope.sortByChanged = function (option) {
                $state.go('.', { sortby: option.Value }, { notify: false }).finally(() => {
                  $rootScope.$broadcast('filter:applied');
                });
            };

            scope.isPrice = function (filterName) {
                return filterName.indexOf(FILTER_TYPE.PRICE) !== -1;
            };

            scope.removeFilter = function (filterName, filter) {
                if (filter.Term) {
                    scope.filtersService.applyFilter(filterName, {
                        Term: filter.Term
                    });
                } else {
                   scope.filtersService.applyFilter(filterName, {
                        Min: filter.Min,
                        Max: filter.Max
                    });
                }
            };
            scope.$on('cardlist:loading', function() {
                scope.isLoading = true;
            });

            scope.$on('cardlist:loaded', function() {
                scope.isLoading = false;
            });

            scope.onToggleHideUnavailableItems = function () {
                scope.hideUnavailableItems = !scope.hideUnavailableItems;
                scope.filtersService.setHideOutOfStockPreference(scope.hideUnavailableItems);
                $rootScope.$broadcast('filter:toggleOOS');
            };

            $timeout(function () {
                FiltersService.getAppliedFilters();
                scope.hideUnavailableItems = scope.filtersService.getHideOutOfStockPreference();
            }, 100);
        },
        template: require('./quick-filters-template.html').trim()
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/filters/quick-filters-directive.js
 **/